import React from 'react';

import './book.css';

const bookingUrl = 'https://www.genifix.jp/coral_dent35-caa/s/login/';

function Book() {
    return (
        <div className="book-section">
            <div className="book-container">
                <div className="book-outer">
                    <h2><i className="fas fa-calendar-check"></i>ネット予約</h2>
                    <p>予約可能な日時は、予約画面からご確認いただけます。</p>
                    <div className="book-contents">
                        <ul>
                            <li>24時間予約可能</li>

                        </ul>
                    </div>
                    <div className="book-links">
                        <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="book-btn">
                            <span>
                                ネット予約ページへ
                                <i className="fas fa-arrow-right"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Book;
